import { Fragment } from 'react';
import { cx } from '../lib/cx.js';
import './kbd.css';

export interface KbdProps {
  /** One chip per key, e.g. ['Ctrl', 'K'] renders Ctrl + K. A sequence uses `then`. */
  keys: readonly string[];
  /** Render as a sequence ("G then S") instead of a chord. */
  sequence?: boolean;
  className?: string;
}

/** Keyboard shortcut chip(s). */
export function Kbd({ keys, sequence = false, className }: KbdProps) {
  return (
    <span className={cx('vel-kbd-group', className)}>
      {keys.map((k, i) => (
        <Fragment key={`${k}-${i}`}>
          {i > 0 && sequence ? <span className="vel-kbd-then">then</span> : null}
          <kbd className="vel-kbd">{k}</kbd>
        </Fragment>
      ))}
    </span>
  );
}
